import {combineReducers} from "redux";
import {
    availableLanguagesReducer as availableLanguages,
    selectedLanguagesReducer as selectedLanguages
} from "./languagesReducer";
import globalInfo from "./globalInfoRducer";
import settings from "./settingsReducer";
import winnerList from "./winnerListReducer";
import history from "./historyReducer";
import viewSetting from "./viewSettingsReducer";
import totalBets from "./totalBetsReducer";
import {userReducer as user} from "./userReducer";
import roundId from "./roundIdReducer";
import timeTicker from "./timeTickerReducer";
import cards from "./cardsReducer";
import odds from "./oddsReducer";
import winner from "./winnerListReducer";
import historyLoading from "./historyLoadingReducer";
import enabledBetAreas from "./enabledBetAreasReducer";
import videoStreamConfig from "./videoStreamReducer";
import activeBets from "./activeBetsReducer";
import gameCondition from "./gameConditionReducer";
import userInfo from "./userInfoReducer";
import alertMessage from "./alertMessagesReducer";
import loadInfo from "./loadInfoReducer";
import gameHistory from "./gameHistoryReducer";
import rules from "./rulesReducer";
import limit from "./limitReducers";
import userWon from "./userWonReducer";
import selectedBoard from "./betReducers/selectedBoardReducer";
import backgroundMusic from "./soundMusic/backgroundMusicReducer";
import sound from "./soundMusic/soundReducer";
import soundKey from "./soundMusic/soundKeyReudcer";
import volume from "./soundMusic/volumeReducer";


const rootReducer = combineReducers({
    globalInfo,
    availableLanguages,
    selectedLanguages,
    settings,
    winnerList,
    history,
    viewSetting,
    totalBets,
    user,
    roundId,
    timeTicker,
    cards,
    odds,
    winner,
    historyLoading,
    enabledBetAreas,
    videoStreamConfig,
    activeBets,
    gameCondition,
    userInfo,
    alertMessage,
    loadInfo,
    gameHistory,
    rules,
    limit,
    userWon,
    selectedBoard,
    backgroundMusic,
    sound,
    soundKey,
    volume
});

export default rootReducer;
